export default import.meta.ROLLUP_FILE_URL_mK73SzZ8kZGpbPDIWGm3XQ